import type { FC, ReactNode } from 'react';
import { QStack } from '../../../QLayouts';

export const FormContent: FC<{ children?: ReactNode }> = ({ children }) => (
  <QStack spacing="16px">{children}</QStack>
);
FormContent.displayName = 'FilterFormContent';
